import axios from "axios";

export default class ToggleAudioEmbeds
{
    constructor ( props )
    {

        this.audioEmbed          = document.querySelector( '.main-audio-embed' );
        this.btnToggleAudioEmbed = document.querySelector( '.btn-toggle-main-audio-embed' );

        if (this.btnToggleAudioEmbed  === null)
        {
            return;
        }

        this.postId = this.btnToggleAudioEmbed.getAttribute("data-id-post");



        // console.log('this.audioEmbed', this.audioEmbed, 'this.btnToggleAudioEmbed', this.btnToggleAudioEmbed);
        if ( this.audioEmbed == null || this.btnToggleAudioEmbed == null )
        {
            return;
        }

        this.bindEvents();

    }

    bindEvents ()
    {


        this.btnToggleAudioEmbed.addEventListener( 'click', (e) =>
        {
            this.toggleAudioEmbed();
        } );

    }


    toggleAudioEmbed ()
    {

        if ( this.audioEmbed.classList.contains( 'closed' ) )
        {
            this.openAudioEmbed();
        }
        else
        {
            this.closeAudioEmbed();
        }
    }


    async openAudioEmbed ()
    {

        this.audioEmbed.classList.remove( 'closed' );
        this.audioEmbed.classList.add( 'open' );

        console.log("openAudioEmebed id : " + this.postId)


        let response = await axios.post(`/endpoints/track/open-audio/posts/${this.postId}`)

        console.log(response);

    }

    closeAudioEmbed ()
    {
        this.audioEmbed.classList.add( 'closed' );
        this.audioEmbed.classList.remove( 'open' );

    }
}
